import css from 'styled-jsx/css';
import { colors } from '../../config/styles/colors';
import { typography } from '../../config/styles/typography';

const SmartSearchCardsStyles = css`
  .smart-search-cards {
    display: flex;
    flex-direction: column;
    gap: ${typography.sm1};
    margin-bottom: ${typography.lg1};
    padding: ${typography.lg};
    border-radius: var(--border-radius);
    background: ${colors.white.shade1};

    @mixin mobileToTablet {
      gap: ${typography.sm1};
      padding: 0 ${typography.xs};
    }

    @mixin tabletToDesktop {
      flex-direction: row;
      margin-left: auto;
      margin-right: auto;
      gap: ${typography.lg};
    }
  }

  .smart-search-card {
    flex: 1;
    background: ${colors.white.shade1};
    border: 1.5px solid ${colors.sky['sky-06']};
    border-radius: 8px;
    padding: ${typography.lg};
    position: relative;
    width: 100%;
    height: 120px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    min-width: 0;

    @mixin mobileToTablet {
      padding: ${typography.lg};
      height: 160px;
    }
  }

  .card-title {
    font-size: ${typography.sm};
    font-weight: 600;
    color: ${colors.black.shade1};
    margin-bottom: ${typography.xs};
    text-align: center;
    line-height: 1.4;
    flex-shrink: 0;
    position: relative;
    padding: 2px ${typography.sm1};
    background-color: ${colors.white.shade1};
    border-radius: 2px;
    margin-top: -27px;
    z-index: 10;
    font-family: Lato, sans-serif;

    @mixin mobileToTablet {
      font-size: ${typography.sm};
      margin-bottom: ${typography.xs1};
    }
  }

  .card-title::before,
  .card-title::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 25px;
    height: 1px;
    background-color: ${colors.sky['sky-06']};
  }

  .card-title::before {
    left: -25px;
  }

  .card-title::after {
    right: -25px;
  }

  .options-container {
    display: flex;
    flex-wrap: wrap;
    gap: ${typography.xs};
    justify-content: center;
    align-items: center;
    flex: 1;
    min-height: 0;

    @mixin mobileToTablet {
      gap: ${typography.xs3};
    }

    @mixin tabletToDesktop {
      justify-content: center;
    }
  }

  .surface-options {
    justify-content: center;
  }

  .smart-search-option {
    background: ${colors.white.shade1};
    border: 1px solid ${colors.gray.shade42};
    border-radius: 8px;
    color: ${colors.black.shade1};
    padding: 6px ${typography.sm1};
    font-size: ${typography.xs};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    outline: none;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    box-sizing: border-box;
    font-family: Lato, sans-serif;
    opacity: 1;

    @mixin mobileToTablet {
      padding: ${typography.xs3} ${typography.sm1};
      font-size: ${typography.sm1};
      min-height: 32px;
    }
  }

  .smart-search-option:hover {
    border-color: ${colors.sky['sky-06']};
    color: ${colors.sky['sky-06']};
    background: ${colors.sky['sky-01']};
  }

  .smart-search-option:focus {
    outline: 2px solid ${colors.sky['sky-06']};
    outline-offset: 2px;
  }

  .smart-search-option:active {
    transform: translateY(1px);
  }

  .option-label {
    flex: 1;
  }

  .remove-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    font-size: ${typography.lg2};
    font-weight: 400;
    line-height: 1;
    margin-left: 4px;
  }
`;

export default SmartSearchCardsStyles;
